import React from 'react';
import {connect} from 'react-redux';

import { callService, goTo } from '../tools';
import LoSentimosForm from '../contrato/lo-sentimos.frm';

const mapState = (state) => {
	return {
		loading: state.global.loading,
		hashOne: state.registro.hashOne,
		hashTwo: state.registro.hashTwo
	};
}

const mapDispatch = (dispatch,ownProps) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},		
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje" : sMensaje });
		},
		pasoRegresar: () => {
			dispatch({ "type": "CONTRATOS_PASO", "paso": 2 });
		},
		finalizar: () => {
			dispatch({ "type": "LIMPIAR_REGISTRO" });
		}
	}
}

class LoSentimos extends React.Component {
	
	submit = (data) => {
		if(data.acepto == true) {
			this.props.pasoRegresar();
		} else {
			let $this = this;
			$this.props.loader(true);
			$this.props.finalizar();
			let llamaServicio = new callService({
				service: 'registro.datosCancelacion',
				secure: true,
				data: {
					hashOne: this.props.hashOne,
					hashTwo: this.props.hashTwo
				}
			}).execute().then((respuesta) => {
				console.log("Respuesta", respuesta);
				$this.props.loader(false);
				goTo("login");
			}).catch((error) => {
				console.log("Error", error);
				$this.props.loader(false);
				$this.props.alerta(error.message.mensaje);
			});
		}
	}

	render() {
		return <LoSentimosForm onSubmit={this.submit} />;
	}
}

export default connect(mapState, mapDispatch)(LoSentimos);


// WEBPACK FOOTER //
// ./src/registro-seguridad/lo-sentimos.cmpt.js